module.exports = __webpack_public_path__ + "static/media/nexxt.727903d2.png";